import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import Notiflix from 'notiflix';
import { CursorComponent } from './components/cursor/cursor';
import { NavComponent } from './components/nav/nav';
import { HeroComponent } from './components/hero/hero';
import { IntroComponent } from './components/intro/intro';
import { TwighShowcaseComponent } from './components/twigh-showcase/twigh-showcase';
import { AmenitiesComponent } from './components/amenities/amenities';
import { ResidencesComponent } from './components/residences/residences';
import { RooftopComponent } from './components/rooftop/rooftop';
import { LocationComponent } from './components/location/location';
import { ContactComponent } from './components/contact/contact';
import { FooterComponent } from './components/footer/footer';
import { WildernessInviteComponent } from './components/wilderness-invite/wilderness-invite';
import { DreamTeamComponent } from './components/dream-team/dream-team';
import { FloorplansComponent } from './components/floorplans/floorplans';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CursorComponent,
    NavComponent,
    HeroComponent,
    IntroComponent,
    TwighShowcaseComponent,
    WildernessInviteComponent,
    AmenitiesComponent,
    ResidencesComponent,
    FloorplansComponent,
    RooftopComponent,
    LocationComponent,
    DreamTeamComponent,
    ContactComponent,
    FooterComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, AfterViewInit {
  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      Notiflix.Notify.init({ closeButton: true });
    }
  }

  ngAfterViewInit() {
    if (!isPlatformBrowser(this.platformId) || typeof document === 'undefined') {
      return;
    }

    const reveals = document.querySelectorAll('.reveal');

    if (typeof IntersectionObserver === 'undefined') {
      reveals.forEach((element) => element.classList.add('visible'));
      return;
    }

    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(element => obs.observe(element));
  }
}
